import React, { useEffect, useLayoutEffect, useRef, useSyncExternalStore } from 'react';
import { useNavigate } from 'react-router-dom';
import { delegation } from '../services/api';

/**
 * Küresel vekalet bandı — vekalet açıkken HER sayfada görünür (App'te monte).
 *
 * Daha önce bant yalnız /grubum'daydı ve bağlam sayfadan çıkınca siliniyordu; owner'ın üye
 * adına belge yükleyebileceği hiçbir ekran kalmıyordu. Bağlam artık sekme-ömürlü; bant nerede
 * olursa olsun KİMİN adına çalışıldığını ve çıkışı gösterir — bunu göstermeyen bir ekranda
 * yapılan her işlem sessizce yanlış kişiye gider sanılabilirdi (aslında sunucu 403 der ama
 * kullanıcı sebebini bilemezdi).
 */

/**
 * Bandın yüksekliği kök elemana CSS değişkeni olarak yazılır; uygulama kabuğu
 * (ProfileLayout) tam ekran yüksekliğini bu kadar KISALTIR.
 *
 * Neden gerekli: kabuk `h-screen`, bant onun ÜSTÜNDE ayrı bir blok. Bant açıkken belge
 * yüksekliği viewport + bant oluyor, yani hiç içeriği olmayan bir sayfada bile ~40px'lik
 * gövde kaydırması doğuyordu. Kullanıcı o kadarını kaydırdığında sticky bant sol menünün
 * ARKASINA giriyordu (menü de z-50 ve DOM'da sonra geldiği için üste boyanıyor) — ekran
 * görüntüsündeki "siyah barın sol kısmı pencere arkasında kalıyor" hatası tam olarak buydu.
 * Bant artık z-[60] ile menünün üstünde; kaydırmanın kendisi de bu değişkenle ortadan kalkıyor.
 */
const BAR_HEIGHT_VAR = '--delegation-bar-h';

function DelegationBanner() {
  const info = useSyncExternalStore(delegation.subscribe, delegation.info);
  const navigate = useNavigate();
  const barRef = useRef(null);

  // Bant sökülünce değişken SIFIRLANMALI: kalırsa vekaletten çıkan kullanıcıda kabuk
  // sebepsiz 40px kısa kalır ve altta bir şerit boşluk görünür.
  useEffect(() => () => {
    document.documentElement.style.setProperty(BAR_HEIGHT_VAR, '0px');
  }, []);

  // Yükseklik ölçülüyor, sabit yazılmıyor: yazı tipi ölçeği ya da uzun bir üye adı satırı
  // büyütebilir. useLayoutEffect: değişken ilk boyamadan ÖNCE yazılsın, kabuk zıplamasın.
  useLayoutEffect(() => {
    const root = document.documentElement;
    if (!info || !barRef.current) {
      root.style.setProperty(BAR_HEIGHT_VAR, '0px');
      return undefined;
    }

    const el = barRef.current;
    const sync = () => root.style.setProperty(BAR_HEIGHT_VAR, `${el.offsetHeight}px`);
    sync();

    if (typeof ResizeObserver === 'undefined') return undefined;   // jsdom
    const observer = new ResizeObserver(sync);
    observer.observe(el);
    return () => observer.disconnect();
  }, [info]);

  if (!info) return null;

  return (
    <div
      ref={barRef}
      /* z-[60]: sol menü (Sidebar) z-50 ve DOM'da bu banttan SONRA geliyor — eşit z-index'te
         sonra gelen üste boyanır ve bandın sol 256px'i menünün arkasında kaybolur. */
      className="sticky top-0 z-[60] bg-viza-black text-white px-4 py-2.5 flex items-center justify-between gap-3"
    >
      <p className="text-sm m-0 min-w-0 truncate">
        <strong>{info.name || 'Üye'}</strong> adına işlem yapıyorsunuz — belge içeriklerini
        göremezsiniz, yalnız yükleyip durumu izleyebilirsiniz.
      </p>
      <button
        type="button"
        onClick={() => { delegation.clear(); navigate('/grubum'); }}
        className="text-sm font-semibold underline bg-transparent border-0 text-white cursor-pointer shrink-0"
      >
        Çık
      </button>
    </div>
  );
}

export default DelegationBanner;
